import {
  APP_INITIALIZER,
  ErrorHandler,
  NgModule,
  provideZoneChangeDetection,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { provideTranslateService } from '@ngx-translate/core';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastComponent } from './shared/lib/common-toast/toast/toast.component';
import { ToasterComponent } from './shared/lib/common-toast/toaster/toaster.component';
import {
  HttpConfigInterceptorInterceptor,
  DEFAULT_TIMEOUT,
} from './service/httpConfigInterceptor/http-config-interceptor.interceptor';
import { AppConst } from './app.constants';
/* import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown'; */
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ScriptService } from './service/scriptService/script.service';
import { CacheService } from './service/cache/cache.service';
import { VersionService } from './service/api/version/version.service';
import { MatButtonModule } from '@angular/material/button';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
// import ClientMonitor from '@sixthsense/sixthsense-javascript-agent';
// import { environmentProd } from 'src/environments/environment.prod';
// import { RakutenService } from './service/rakuten.service';

export function clearIndexHtmlCache(cacheService: CacheService) {
  return () => cacheService.clearCacheForFile('index.html');
}

export class AppGlobalErrorhandler implements ErrorHandler {
  handleError(error: any) {
    // ClientMonitor.reportFrameErrors({
    //   collector: environmentProd.RAKUTEN_COLLECTOR,
    //   service: environmentProd.RAKUTEN_SERVICE_NAME,
    //   serviceVersion: environmentProd.RAKUTEN_SERVICE_VERSION,
    //   pagePath: location.href,
    //   useFmp: true,
    //   authorization: environmentProd.RAKUTEN_AUTH,
    // },error);
  }
}

@NgModule({
  declarations: [AppComponent, ToastComponent, ToasterComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule,
    MatButtonModule,
    MatBottomSheetModule,
  ],
  providers: [
    CacheService,
    {
      provide: APP_INITIALIZER,
      useFactory: clearIndexHtmlCache, //<--- calling function on Angular App init
      deps: [CacheService], //<---- Important deps
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptorInterceptor,
      multi: true,
    },
    { provide: DEFAULT_TIMEOUT, useValue: AppConst.DEFAULT_TIMEOUT },
    // { provide: ErrorHandler, useClass: AppGlobalErrorhandler},
    ScriptService,
    VersionService,
    provideZoneChangeDetection(),
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService(),
    provideTranslateHttpLoader(),
  ],
})
export class AppModule {}
